import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TrackChangesIcon(props: IconProps) {
    return <Icon {...props} iconKey={"track_changes"}/>
}
